import * as angular from 'angular';
import {IController} from "angular";

export class depotDisplayValueCtrl implements IController {
  id: any;

  private selectedDepot: any;

  /* @ngInject */
  constructor(private $depots, private $log) {
  }

  $onInit() {
    this.setItem(this.id);
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.setItem(this.id);
    }
  }

  private setItem(id) {
    if (id) {
      this.$depots(id).$asyncValue()
        .then((depot) => {
          this.selectedDepot = depot;
        })
        .catch((error) => {
          this.$log.error('Failed to get depots', error);
        })
    } else {
      this.selectedDepot = undefined;
    }
  }



}

angular
  .module('bringoz.admin.depots')
  .component('depotDisplayValue', {
    bindings: {
      id: '<',
      onChange: '&'
    },
    template: require('./depot-display-value.html').default,
    controller: depotDisplayValueCtrl
  });
